<template>
  <div class="bg">
    <div id="chat">
      <div class="sidebar">
        <kt-panel></kt-panel>
      </div>
      <div class="main">
        <kt-header></kt-header>
        <kt-content></kt-content>
        <kt-tool></kt-tool>
      </div>
    </div>
  </div>
</template>

<script>
  import {saveLocal, loadLocal} from 'common/js/store.js';

  import {login} from '@/common/im/api'
  import {socket} from '@/common/im/socket'

  import KtPanel from './components/panel'
  import KtHeader from './components/header'
  import KtContent from './components/content'
  import KtTool from './components/tool'

  export default {
  	data() {
  		return {
        id: (() => loadLocal('id', false))(),
      }
    },
    methods:{
      queryUserInfo(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'user',
            a: 'userinfo',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.userLogin(response);
          }
        }).catch((err) => {

        })
      },
      async userLogin (userinfo) {

        let info = {
          user_id: userinfo.userid,
          name: decodeURIComponent(userinfo.uname),
          headImage: userinfo.headimg
        };
        console.log(info);
        this.$store.commit('SET_USER_INFO',info);
        this.addConversation();
        try{
          const res = await login(info);
          console.log(res);
          if (res.code === 200) {
            socket.init(res.data.auth_token);
            this.$store.commit('SET_USERID',info.user_id);
            this.$store.dispatch('loadChatData',info.user_id);
          } else {
            this.$message.error(res.message);
          }
        }catch(err){
          this.$message.error('服务器连接失败');
          console.log(err);
        }
      },
      addConversation() {
      	let uid = this.$route.query.uid;
        if (uid) {
          this.$store.dispatch('addConversation',uid);
        }
      }
    },
    created(){

      this.queryUserInfo();

    },
    components: {
      KtPanel,
      KtHeader,
      KtContent,
      KtTool
    }
  }
</script>

<style lang="scss" scoped>
  .bg {
    background: #f5f5f5 url(./bg.jpg) no-repeat center;
    background-size: cover;
    height: 100%;
    overflow: auto;
    position: relative;
    min-width: 1060px;
    min-height: 740px;
    #chat {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -340px 0 0 -500px;

      width: 1000px;
      height: 680px;
      overflow: hidden;
      border-radius: 3px;
      .sidebar, .main {
        height: 100%;
      }
      .sidebar {
        float: left;
        width: 280px;
        background-color: #2e3239;
      }
      .main {
        position: relative;
        background-color: #eee;
        display: flex;
        flex-direction: column;
        float: left;
        width: 720px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/chat/chat.vue